import React, { useState, useEffect } from 'react'
import Autocomplete from '../Shared/AutosuggestV2/Autosuggestv2'
import Select from 'react-select/creatable'
import { isMobile as checkIsMobile } from '../../Constants'
import classes from '../TrucksAvailable/TrucksAvailable.module.css'
import classes1 from './Indent.module.css'

// ===== CONSTANTS =====
const LABEL_STYLE = { fontWeight: 'unset', fontSize: '14px' }

const AUTOCOMPLETE_STYLES = {
  placeholder: (base) => ({ ...base, fontWeight: '500' }),
  input: (base) => ({ ...base, fontWeight: '500' }),
  singleValue: (base) => ({ ...base, fontWeight: '500' }),
  valueContainer: (base) => ({ ...base, padding: '0px 16px' }),
}

const TRUCK_SELECT_STYLES = {
  groupHeading: (base) => ({
    ...base,
    color: 'black',
    fontWeight: 'bold',
    fontSize: '14px',
    textTransform: 'none',
    marginLeft: '10px',
  }),
}

const formatTruckLabel = ({ label, isMyTruck }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {isMyTruck && (
      <i
        className="fa fa-truck"
        style={{ marginRight: '8px', color: '#393185', fontSize: '14px' }}
      />
    )}
    <div>{label}</div>
  </div>
)

// ===== TIME MODAL =====
const TimeModal = ({ mobile, tempStartTime, tempEndTime, setTempStartTime, setTempEndTime, onSave, onCancel }) => {
  const modalContentStyle = mobile
    ? { background: '#fff', padding: '15px', borderRadius: '10px', width: '85%', maxWidth: '340px', boxShadow: '0 3px 10px rgba(0,0,0,0.3)' }
    : { background: '#fff', padding: '20px', borderRadius: '8px', width: '320px', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }

  const headingTag = mobile ? 'h6' : 'h5'

  const timeInputStyle = {
    width: '100%',
    height: '36px',
    marginTop: '4px',
    ...(mobile ? { borderRadius: '4px', border: '1px solid #ccc' } : {}),
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div style={modalContentStyle}>
        {React.createElement(headingTag, { style: { textAlign: 'center', marginBottom: '1rem' } }, 'Select Time of Placement')}

        <div style={{ marginBottom: '1rem' }}>
          <label><b>From:</b></label>
          <input type="time" style={timeInputStyle} value={tempStartTime} onChange={(e) => setTempStartTime(e.target.value)} />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label><b>To:</b></label>
          <input type="time" style={timeInputStyle} value={tempEndTime} onChange={(e) => setTempEndTime(e.target.value)} />
        </div>

        <div style={{ display: 'flex', justifyContent: mobile ? 'space-around' : 'flex-end', gap: '10px' }}>
          <button
            onClick={onCancel}
            style={{
              backgroundColor: '#ccc',
              border: 'none',
              padding: mobile ? '6px 18px' : '6px 12px',
              borderRadius: mobile ? '5px' : '4px',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            style={{
              backgroundColor: '#393185',
              color: '#fff',
              border: 'none',
              padding: mobile ? '6px 18px' : '6px 12px',
              borderRadius: mobile ? '5px' : '4px',
              cursor: 'pointer',
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

// ===== MAIN COMPONENT =====
const AddIndent = ({
  inputorigin,
  setorigin,
  setinputorigin,
  inputdestination,
  setdestination,
  setinputdestination,
  TruckTypes,
  selectedTrucks,
  todaydate,
  addLanetoProcurement,
  onChangeTruckTypes,
  setduedate,
  truckrequired,
  settruckrequired,
  setDopStartTime,
  setDopEndTime,
  dopStartTime,
  dopEndTime,
  isRestricted,
}) => {
  const mobile = checkIsMobile()
  const companyId = localStorage.getItem('profile_company_id')

  const [showTimeModal, setShowTimeModal] = useState(false)
  const [tempStartTime, setTempStartTime] = useState(dopStartTime || '')
  const [tempEndTime, setTempEndTime] = useState(dopEndTime || '')

  useEffect(() => {
    if (showTimeModal) {
      setTempStartTime(dopStartTime || '')
      setTempEndTime(dopEndTime || '')
    }
  }, [showTimeModal, dopStartTime, dopEndTime])

  const isTimeSelected = Boolean(dopStartTime && dopEndTime)
  const clockIconColor = isTimeSelected ? '#28a745' : '#000'

  const handleSaveTimes = () => {
    setDopStartTime(tempStartTime)
    setDopEndTime(tempEndTime)
    setShowTimeModal(false)
  }

  // ===== SHARED FIELD RENDERERS =====
  const renderOrigin = (wrapperStyle) => (
    <div className={classes['s-tt']}>
      <label style={LABEL_STYLE}>
        <b>Plant / Origin <span className="required-field"> *</span></b>
      </label>
      <label style={wrapperStyle}>
        <Autocomplete
          value={inputorigin ? { label: inputorigin, value: inputorigin } : null}
          placeholder="Origin"
          className={classes['originn']}
          user_identifier={companyId}
          module_key="indents"
          isDisabled={isRestricted}
          onChange={(val) => setinputorigin(val)}
          onSelect={(obj) => {
            setorigin(obj)
            setinputorigin(obj?.location_name || obj?.value || '')
          }}
          customStyles={AUTOCOMPLETE_STYLES}
        />
      </label>
    </div>
  )

  const renderDestination = (wrapperStyle) => (
    <div className={classes['s-tt']}>
      <label style={LABEL_STYLE}>
        <b>Destination <span className="required-field"> *</span></b>
      </label>
      <label style={wrapperStyle}>
        <Autocomplete
          value={inputdestination ? { label: inputdestination, value: inputdestination } : null}
          placeholder="Destination"
          className="origin"
          user_identifier={companyId}
          module_key="indents"
          isDisabled={isRestricted}
          onChange={(val) => setinputdestination(val)}
          onSelect={(obj) => {
            setdestination(obj)
            setinputdestination(obj?.location_name || obj?.value || '')
          }}
          customStyles={AUTOCOMPLETE_STYLES}
        />
      </label>
    </div>
  )

  const renderTruckType = (containerStyle) => (
    <div style={containerStyle} className={classes['s-tt']}>
      <label style={LABEL_STYLE}>
        <b>Truck Type <span className="required-field"> *</span></b>
      </label>
      <label className={`${classes['s-truck-type-select']} boxes`} style={!mobile ? { width: '97%' } : undefined}>
        <Select
          options={TruckTypes}
          onChange={onChangeTruckTypes}
          value={selectedTrucks}
          className={`Truck_Type_Select${mobile ? ` ${classes1['truckType']}` : ''}`}
          classNamePrefix="Truck_Prefix"
          isDisabled={isRestricted}
          styles={TRUCK_SELECT_STYLES}
          formatOptionLabel={formatTruckLabel}
        />
      </label>
    </div>
  )

  const renderTruckCount = () => (
    <div style={!mobile ? { width: '8%' } : undefined} className={classes['s-tt']}>
      <label style={LABEL_STYLE}>
        <b># Trucks <span className="required-field"> *</span></b>
      </label>
      <label className={`${classes['s-truck-type-select']} boxes`}>
        <input
          className={`${classes1['truckQuantity1']} origin`}
          style={{ height: '38px' }}
          type="number"
          placeholder="0"
          value={truckrequired}
          onChange={(e) => settruckrequired(e.target.value)}
          disabled={isRestricted}
        />
      </label>
    </div>
  )

  const renderDateOfPlacement = () => (
    <div className={classes['s-tt']} style={{ position: 'relative' }}>
      <label style={LABEL_STYLE}>
        <b>Date of Placement <span className="required-field"> *</span></b>
      </label>
      <div style={{ position: 'relative', width: '100%' }}>
        <input
          style={{ height: '38px', width: '100%', paddingRight: '34px' }}
          type="date"
          className="date-input-with-icon"
          defaultValue={todaydate}
          min={todaydate}
          onInput={(e) => setduedate(e.target.value)}
          disabled={isRestricted}
        />
        <i
          className="fa fa-clock-o"
          title="Set Start & End Time"
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '18px',
            color: clockIconColor,
            opacity: isRestricted ? 0.6 : 1,
            cursor: isRestricted ? 'not-allowed' : 'pointer',
          }}
          onClick={() => !isRestricted && setShowTimeModal(true)}
        />
      </div>

      {showTimeModal && (
        <TimeModal
          mobile={mobile}
          tempStartTime={tempStartTime}
          tempEndTime={tempEndTime}
          setTempStartTime={setTempStartTime}
          setTempEndTime={setTempEndTime}
          onSave={handleSaveTimes}
          onCancel={() => setShowTimeModal(false)}
        />
      )}
    </div>
  )

  const renderAddButton = () => (
    <div style={!mobile ? { zIndex: '10', marginLeft: '30px' } : undefined}>
      <button
        style={{ fontSize: '150%', background: 'none', border: 'none', padding: 0 }}
        onClick={addLanetoProcurement}
        className={`fa fa-plus-circle ${classes['s-icon']}`}
        disabled={isRestricted}
      />
    </div>
  )

  // ===== LAYOUT =====
  if (mobile) {
    return (
      <div style={{ padding: '0 4%', width: '100%', boxSizing: 'border-box' }}>
        {renderOrigin({ width: '100%', marginBottom: '8px' })}
        {renderDestination({ width: '100%', marginBottom: '8px' })}
        {renderTruckType()}
        {renderTruckCount()}
        {renderDateOfPlacement()}
        {renderAddButton()}
      </div>
    )
  }

  return (
    <div style={{ marginTop: '1%' }} className="row">
      <div
        style={{ flexBasis: '77%', width: '87%', zIndex: '3' }}
        className={`${classes1['latest-inputs']} ${classes1['input-div']}`}
      >
        {renderOrigin({ width: '98%', marginBottom: '2%' })}
        {renderDestination({ width: '98%' })}
        {renderTruckType({ width: '20%' })}
        {renderTruckCount()}
        {renderDateOfPlacement()}
        {renderAddButton()}
      </div>
    </div>
  )
}

export default AddIndent